module.exports = __webpack_public_path__ + "static/media/babyAccessoriesMore.af65db61.webp";